"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PDFErrorComponent = _interopRequireDefault(require("./PDFErrorComponent"));
var _reactPdf = require("react-pdf");
var _utils = require("../../utils");
/**
 * @typedef { 'error' | 'loadError' | 'noData' | 'sourceError' } PDFErrorType
 */

/**
 * Wrapper around react-pdf's Document component
 * @param {Object} props
 * @returns {React.ReactElement}
 */
var StudioPDFDocument = function StudioPDFDocument(props) {
  var errorIconSize = props.errorIconSize;

  /**
   * onError is a function that will be called when the PDF fails to load
   * @param {Error} error
   * @param {PDFErrorType} type - The type of error. Default is 'error'.
   * @returns {React.ReactElement}
   */
  var onError = function onError(error) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'error';
    var loggingMessage;

    // generate an appropriate logging message based on the error type
    switch (type) {
      case 'loadError':
        loggingMessage = 'Encountered an error while loading PDF file';
        break;
      case 'noData':
        loggingMessage = 'No PDF data to render';
        break;
      case 'sourceError':
        loggingMessage = 'Unable to load PDF source';
        break;
      case 'error':
      default:
        loggingMessage = 'Encountered an error while rendering PDF file';
        break;
    }

    // send the logging message and error to Datadog
    (0, _utils.sendToDatadog)('pdf-page', error, loggingMessage, true);
    if (type === 'error' && props.error) return props.error;
    if (type === 'noData' && props.noData) return props.noData;

    // return error component if we are not logging the error only
    if (type !== 'loadError' && type !== 'sourceError') return /*#__PURE__*/_react["default"].createElement(_PDFErrorComponent["default"], {
      size: errorIconSize
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_reactPdf.Document, (0, _extends2["default"])({}, props, {
    error: /*#__PURE__*/_react["default"].createElement(_PDFErrorComponent["default"], {
      size: errorIconSize
    }),
    loading: '',
    onLoadError: function onLoadError(error) {
      return onError(error, 'loadError');
    },
    onSourceError: function onSourceError(error) {
      return onError(error, 'sourceError');
    },
    noData: /*#__PURE__*/_react["default"].createElement(_PDFErrorComponent["default"], {
      size: errorIconSize
    })
  }));
};

/**
 * Default props for the StudioPDFDocument component.
 * @type {Object}
 * @property {string} errorIconSize - The size of the error icon. Default is 'medium'.
 */
StudioPDFDocument.defaultProps = {
  errorIconSize: 'medium'
};

/**
 * Prop types for the StudioPDFDocument component.
 * @type {Object}
 * @property {React.ReactNode} error - The error message to display when the PDF fails to load.
 * @property {string} errorIconSize - The size of the error icon.
 * @property {React.ReactNode} loading - The loading message to display while the PDF is loading.
 * @property {React.ReactNode} noData - The message to display when there is no data to render.
 */
StudioPDFDocument.propTypes = {
  error: _propTypes["default"].node,
  errorIconSize: _propTypes["default"].oneOf(['small', 'medium', 'large']),
  loading: _propTypes["default"].node,
  noData: _propTypes["default"].node
};
var _default = exports["default"] = StudioPDFDocument;